import { type FC } from "react";
import { Lock } from "lucide-react";

import { cn } from "@/shared/utils/core";

const SIZE_STYLES = {
  sm: { icon: "h-3 w-3", text: "text-2xs" },
  md: { icon: "h-3.5 w-3.5", text: "text-xs" },
  lg: { icon: "h-4 w-4", text: "text-sm" },
} as const;

export type SecurityNoteSize = keyof typeof SIZE_STYLES;
export type SecurityNoteAlign = "center" | "left";

interface SecurityNoteProps {
  text: string;
  size?: SecurityNoteSize;
  align?: SecurityNoteAlign;
  className?: string;
}

export const SecurityNote: FC<SecurityNoteProps> = ({
  text,
  size = "sm",
  align = "center",
  className,
}) => {
  const sizeClasses = SIZE_STYLES[size];
  const isLeft = align === "left";

  return (
    <div
      className={cn(
        "flex gap-2",
        isLeft ? "items-start justify-start" : "items-center justify-center",
        className,
      )}
    >
      <Lock
        className={cn(sizeClasses.icon, "shrink-0 text-tertiary", isLeft && "mt-0.5")}
        aria-hidden="true"
      />
      <p className={cn(sizeClasses.text, "text-secondary")}>{text}</p>
    </div>
  );
};
